import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../app/api/routes';
import { RELATION_TYPES_RESOURCE, CREATE_RELATION_TYPE_RESOURCE } from '../constants';
import { createErrorMessage } from '../../app/helpers/createErrorMessage';

const CreateRelationTypeService = ComposedComponent =>
  reduxFetch([
    {
      resource: CREATE_RELATION_TYPE_RESOURCE,
      method: 'post',
      request: (body, callback, t) => ({
        url: apiRoutes.relationTypes(),
        body,
        meta: {
          callback,
          addToOtherList: { resource: RELATION_TYPES_RESOURCE },
          toaster: {
            onErrorMessage: createErrorMessage(t, 'createRelationTypeFailed'),
            onSuccessMessage: t('createRelationTypeSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default CreateRelationTypeService;
